module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "breadcrumb is-small",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n              Home\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'songs'
      }
    }
  }, [_vm._v("\n              Songs\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(_vm.song ? _vm.song.title : ""))])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [(_vm.song) ? _c('div', {
    staticClass: "container"
  }, [(_vm.editMode) ? _c('song-edit', {
    attrs: {
      "initial-song": _vm.song
    },
    on: {
      "update": function($event) {
        return _vm.updateSelectedSong($event)
      }
    }
  }) : _c('div', [(_vm.wakeLockAvailable()) ? _c('button', {
    staticClass: "button",
    class: [_vm.isWakeLocked ? 'is-active' : ''],
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.toggleWakeLock()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa-lightbulb",
    class: [_vm.isWakeLocked ? 'fas' : 'far']
  })])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button",
    class: _vm.knowledgeClassObject,
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.changeKnowledge()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fas fa-guitar"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-bottom": "1.5em"
    }
  }, [_c('div', {
    staticClass: "buttons has-addons"
  }, [_c('button', {
    staticClass: "button",
    class: [_vm.format === 'chords' ? 'is-static' : ''],
    on: {
      "click": function($event) {
        return _vm.setFormatter('chords')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fas fa-poll-h"
  })]), _vm._v(" "), _c('span', [_vm._v("Text and chords")])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    class: [_vm.format === 'text' ? 'is-static' : ''],
    on: {
      "click": function($event) {
        return _vm.setFormatter('text')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fas fa-align-left"
  })]), _vm._v(" "), _c('span', [_vm._v("Text only")])])])]), _vm._v(" "), (_vm.song.title) ? _c('div', [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "display": "inline-block",
      "margin-bottom": "1.5rem",
      "margin-right": "0.5rem"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.song.title) + "\n          ")]), _vm._v(" "), _c('button', {
    class: [
      'button',
      'is-inverted',
      _vm.quality === 2 ?
      'is-success' :
      _vm.quality === 1 ?
      'is-info' :
      'is-danger'
    ],
    on: {
      "click": function($event) {
        return _vm.changeQuality()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    class: _vm.qualityClassObject
  })])])]) : _vm._e(), _vm._v(" "), (_vm.song.properties && _vm.song.properties.couvent_index) ? _c('h2', {
    staticClass: "subtitle has-text-grey-light",
    staticStyle: {
      "margin-top": "-1.25rem"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.song.properties.couvent_index) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.song.song) ? _c('div', {
    staticClass: "song-tags"
  }, [_c('div', {
    staticClass: "field is-grouped is-grouped-multiline"
  }, _vm._l((_vm.song.song.tags), function(tag) {
    return _c('div', {
      key: tag.id,
      staticClass: "control"
    }, [_c('div', {
      staticClass: "tags has-addons"
    }, [_c('a', {
      staticClass: "tag is-link"
    }, [_vm._v(_vm._s(tag.name))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lyrics",
    class: 'format-' + _vm.format,
    domProps: {
      "innerHTML": _vm._s(_vm.songHTML)
    }
  })]), _vm._v(" "), (_vm.editMode) ? _c('a', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        return _vm.remove()
      }
    }
  }, [_c('span', [_vm._v("Delete")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "add button is-large is-warning",
    on: {
      "click": function($event) {
        return _vm.toggleEdit()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-medium"
  }, [(_vm.editMode) ? _c('i', {
    staticClass: "fas fa-check"
  }) : _c('i', {
    staticClass: "fas fa-pencil-alt"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21c9c57d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Song.vue
// module id = 314
// module chunks = 2